<div class="dialog-content-wrapper">
    <div class="dialog-header">
        <div>
            <h2 class="dialog-title">{{ "TOOLBAR.BrowserNotificationsTitle" | translate }}</h2>
        </div>

        <button mat-icon-button type="button" (click)="close()" aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="dialog-body">
        @if (viewState !== "enabled" || !hasProjectContext) {
            <div class="dialog-message">
                {{ stateMessage }}
            </div>
        }

        @if (viewState === "enabled" && hasProjectContext) {
            <div class="project-setting-row">
                <div class="project-setting-row__content">
                    <div class="project-setting-row__meta">
                        {{ "TOOLBAR.BrowserNotificationsCurrentProject" | translate }}
                    </div>
                    <div class="project-setting-row__name">
                        {{ data.projectName }}
                    </div>
                    <div class="project-setting-row__status">
                        {{ projectStateMessage }}
                    </div>
                </div>
                <mat-slide-toggle
                    class="project-setting-row__toggle"
                    color="primary"
                    [checked]="!browserNotificationsDisabledForProject"
                    [disabled]="updating"
                    (change)="toggleProjectNotifications($event.checked)"
                    [aria-label]="'TOOLBAR.BrowserNotificationsProjectToggle' | translate"
                ></mat-slide-toggle>
            </div>
        }

        @if (viewState === "ready") {
            <div class="dialog-actions">
                <button
                    mat-stroked-button
                    type="button"
                    class="dialog-button dialog-button--secondary"
                    (click)="close()"
                >
                    {{ "TOOLBAR.BrowserNotificationsSkip" | translate }}
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    type="button"
                    class="dialog-button dialog-button--primary"
                    (click)="enableNotifications()"
                    [disabled]="updating"
                >
                    {{ "TOOLBAR.BrowserNotificationsEnableAction" | translate }}
                </button>
            </div>
        }
    </mat-dialog-content>
</div>
